import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

export function PartialDataBanner({ show }) {
  if (!show) return null;
  return (
    <div className="ou-banner">
      <FaExclamationTriangle />
      <div>
        <strong>Partial data:</strong> the query timed out or was truncated.
        Metrics may be undercounted for large organizations or long date ranges.
      </div>
    </div>
  );
}
